import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import {
  Section,
  SimpleCallToActionBanner,
  LogoCarousel,
  AitoShowcases,
  QuotesBlock,
  ThreeColumnsList,
  LatestBlogList,
  AlternatingStories,
  IndustrySolutions,
  Button,
  PerformancePanel,
  UseCaseCarousel
} from '..'
import * as styles from './styles'

const propTypes = {
  data: PropTypes.object.isRequired,
  latestBlog: PropTypes.array.isRequired
}

export default function IndexContent({ data, latestBlog }) {
  const aitoFeaturesIcons = [
    (
      <styles.IconWrapper color="green">
        <styles.RealTimeLearningIcon />
      </styles.IconWrapper>
    ),
    (
      <styles.IconWrapper color="pink">
        <styles.PredictAnyVariableIcon />
      </styles.IconWrapper>
    ),
    (
      <styles.IconWrapper color="blue">
        <styles.HiddenMagicIcon />
      </styles.IconWrapper>
    )
  ]

  return (
    <>
      <Section>
        <styles.Container>

          {data.useCaseCarousel && (
            <UseCaseCarousel cases={data.useCaseCarousel} />
          )}

          {data.industrySolutions && (
            <styles.IndustrySolutionsContainer>
              <IndustrySolutions
                header={data.industrySolutionsHeader}
                solutions={data.industrySolutions}
              />
            </styles.IndustrySolutionsContainer>
          )}

        <styles.PerformanceContainer>
          <styles.SectionContainer>
            <PerformancePanel 
              variant="standard"
              showTitle={true}
              customTitle="Production-Proven Performance"
              showHardwareNote={true}
            />
          </styles.SectionContainer>
        </styles.PerformanceContainer>

        <styles.LogoContainer>
          <styles.SectionContainer>
            <LogoCarousel />
          </styles.SectionContainer>
        </styles.LogoContainer>

        <styles.PlusPatternContainer>
          <styles.SectionContainer>
            <ThreeColumnsList
              header={data.aitoFeaturesHeader}
              items={data.aitoFeatures}
              icons={aitoFeaturesIcons}
            />
          </styles.SectionContainer>
        </styles.PlusPatternContainer>

        <styles.QuoteContainer>
          <QuotesBlock data={data} />
        </styles.QuoteContainer>

        {data.technologyCtaHeader && (
          <styles.TechnologyCtaContainer>
            <styles.TechnologyCtaContent>
              <styles.TechnologyCtaHeader>
                Built for <span style={{ color: 'white' }}>Enterprise Scale</span> and Developer Productivity
              </styles.TechnologyCtaHeader>
              <styles.TechnologyCtaText>{data.technologyCtaText}</styles.TechnologyCtaText>
              <styles.TechnologyCtaButton>
                <Link to={data.technologyCtaButtonUrl}>
                  <Button size="large">
                    {data.technologyCtaButtonText}
                  </Button>
                </Link>
              </styles.TechnologyCtaButton>
            </styles.TechnologyCtaContent>
          </styles.TechnologyCtaContainer>
        )}

        <styles.PlusPatternContainer>
          <styles.SectionContainer>
            <AitoShowcases showcases={data.showcases} header={data.showcasesHeader} />
          </styles.SectionContainer>
        </styles.PlusPatternContainer>

        <styles.SectionContainer>
          <LatestBlogList header={data.latestBlogHeader} blog={latestBlog} />
        </styles.SectionContainer>

        <SimpleCallToActionBanner />
      </styles.Container>
    </Section>
    
    {/* AlternatingStories replaced by UseCaseCarousel above */}
    </>
  )
}

IndexContent.propTypes = propTypes
